{
  "_meta": {
    "_comment": "Phase 6 Wave 3 Tasks 07+08+09+10 — products namespace EN. vg-binding: PLAN:task-07 / PLAN:task-08 / PLAN:task-09 / PLAN:task-10 / P6.D-15..24 / P6.D-34 / P6.D-38 / P6.D-39 / P6.D-43..50 / P6.D-51..58 / P6.D-139 / P6.D-148 / P6.D-207 / P6.D-209 / P6.D-220",
    "locale": "en",
    "completeness": "secondary"
  },
  "editor": {
    "unsavedGuard": {
      "title": "Leave with unsaved changes?",
      "body": "You have unsaved changes. Leaving now will discard them.",
      "stay": "Stay",
      "leave": "Leave & discard"
    },
    "title": {
      "placeholder": "Product name…"
    },
    "tabs": {
      "general": "General",
      "variants": "Variants",
      "pricing": "Pricing",
      "media": "Media",
      "seo": "SEO"
    },
    "actions": {
      "save": "Save",
      "saving": "Saving…",
      "cancel": "Cancel",
      "publish": "Publish",
      "delete": "Delete",
      "stay": "Stay",
      "leave": "Leave",
      "unsavedTitle": "Unsaved changes",
      "unsavedWarning": "You have unsaved changes. Leaving will discard them.",
      "unsavedMarker": "• unsaved",
      "saved": "Product saved",
      "saveFailed": "Save failed",
      "noChanges": "No changes to save"
    },
    "status": {
      "draft": "Draft",
      "active": "Active",
      "archived": "Archived"
    },
    "fields": {
      "name": "Product name",
      "description": "Description",
      "descriptionPlaceholder": "Markdown supported…",
      "category": "Category",
      "categoryReadonly": "from blueprint",
      "tags": "Tags",
      "tagsPlaceholder": "Add tag and press Enter",
      "removeTag": "Remove {{tag}}"
    },
    "changelog": {
      "banner": "Blueprint v{{latest}} is available. Pinned version: v{{pinned}}.",
      "viewDiff": "View changes"
    },
    "variant": {
      "intro": "Manage SKU, inventory, and per-variant pricing.",
      "add": "Add variant",
      "remove": "Remove",
      "retire": "Retire",
      "restrictedBadge": "Reserved",
      "restrictedTitle": "This SKU is reserved for another merchant, so it cannot be ordered or edited. Contact your account manager to change it.",
      "size": "Size",
      "color": "Color",
      "sku": "SKU",
      "trackInventory": "Track inventory",
      "trackOn": "On",
      "trackOff": "Off",
      "inventory": "Inventory",
      "priceOverride": "Override (¢)",
      "actions": "Actions",
      "empty": "No variants yet. Click \"Add variant\" to create the first row."
    },
    "pricing": {
      "defaultsTitle": "Default tier pricing",
      "defaultsHint": "Unit: cents. Applied when no per-store override exists.",
      "storesTitle": "Per-store pricing",
      "store": "Store",
      "empty": "No connected stores.",
      "tier": {
        "titanium": "Titanium",
        "platinum": "Platinum",
        "diamond": "Diamond"
      }
    },
    "media": {
      "addByUrl": "Add image by URL",
      "add": "Add",
      "empty": "No images yet. Paste a URL to add one.",
      "setPrimary": "Set as primary"
    },
    "seo": {
      "metaTitle": "Meta title",
      "metaDescription": "Meta description",
      "slug": "URL slug",
      "slugHint": "Lowercase letters, numbers, and hyphens only."
    },
    "publish": {
      "confirmTitle": "Publish product to stores?",
      "confirmDesc": "Pick the stores you want to sync this product to.",
      "noStores": "No connected stores."
    },
    "delete": {
      "confirmTitle": "Delete \"{{name}}\"?",
      "confirmDesc": "This will remove the product from public listings.",
      "softNote": "Soft delete — recoverable within 30 days."
    },
    "notFound": {
      "title": "Product not found",
      "back": "Back to My Products"
    }
  },
  "myProducts": {
    "title": "My Products",
    "subtitle": "Manage your product catalog and store listings.",
    "fromPrice": "From {{price}}",
    "variantCount": "{{count}} variants",
    "loadMore": "Load more",
    "loadingMore": "Loading…",
    "cta": {
      "add": "Add New Product",
      "bulkImport": "Bulk import",
      "settings": "Product settings"
    },
    "tabs": {
      "label": "Status filter",
      "all": "All",
      "active": "Active",
      "draft": "Draft",
      "archived": "Archived",
      "inactive": "Inactive"
    },
    "filters": {
      "category": "Category",
      "syncStatus": "Sync",
      "store": "Store",
      "search": "Search products…",
      "viewMode": "View mode",
      "table": "Table",
      "grid": "Grid",
      "allStores": "All stores",
      "baseProduct": "Base product",
      "allBaseProducts": "All base products",
      "searchBaseProduct": "Search base product…",
      "loadingBaseProduct": "Loading…",
      "noBaseProduct": "No base products",
      "refineSearch": "Type to narrow…"
    },
    "sort": {
      "createdDesc": "Newest",
      "createdAsc": "Oldest",
      "nameAsc": "Name: A → Z",
      "nameDesc": "Name: Z → A",
      "lastModifiedDesc": "Recently modified",
      "syncStatus": "Sync status"
    },
    "sync": {
      "pending": "Pending",
      "syncing": "Syncing",
      "synced": "Synced",
      "failed": "Failed",
      "moreStores": "{{n}} more stores"
    },
    "actions": {
      "menu": "Row actions",
      "view": "View",
      "edit": "Edit",
      "duplicate": "Duplicate",
      "publish": "Publish to store",
      "archive": "Archive",
      "delete": "Delete",
      "unarchive": "Restore to draft"
    },
    "bulk": {
      "selected": "{{count}} selected",
      "publish": "Bulk publish",
      "archive": "Bulk archive",
      "delete": "Bulk delete",
      "clear": "Clear selection",
      "confirmDeleteTitle": "Delete selected products?",
      "confirmDeleteBody": "You are about to delete {{count}} product(s). This cannot be undone.",
      "confirmDeleteConfirm": "Delete",
      "confirmDeleteCancel": "Cancel"
    },
    "empty": {
      "all": "No products yet.",
      "active": "No active products yet.",
      "draft": "No draft products yet. Create one?",
      "archived": "No archived products yet.",
      "cta": "Add product",
      "titles": {
        "all": "Create your first product",
        "draft": "No drafts yet",
        "active": "No active products yet",
        "archived": "No archived products"
      },
      "bodies": {
        "all": "Pick a blueprint and customize your own design — or import a CSV in bulk.",
        "draft": "Save in-progress products as drafts to finish later. Browse the catalog to start.",
        "active": "Finish a draft and click Publish to push your product live to connected stores.",
        "archived": "Archived products show up here. You can restore them anytime."
      },
      "ctas": {
        "create": "Create your first product",
        "browseCatalog": "Browse Catalog",
        "publishDraft": "Publish your first draft",
        "bulkImport": "Or bulk import"
      }
    },
    "bulkImport": {
      "subtitle": "Upload a CSV/XLSX to create many products at once. Up to {{n}} rows per import.",
      "close": "Close",
      "dropHint": "Drag & drop a CSV/XLSX here",
      "dropSubhint": "or click to choose a file",
      "title": {
        "upload": "Bulk import products",
        "preview": "Preview data",
        "importing": "Importing…",
        "result": "Import result"
      },
      "actions": {
        "back": "Back",
        "import": "Import products",
        "cancel": "Cancel",
        "importing": "Working…",
        "done": "Done"
      },
      "template": {
        "title": "Need a template?",
        "subtitle": "Download our CSV template — required columns + sample data.",
        "download": "Download template"
      },
      "preview": {
        "summary": "{{rows}} rows · {{cols}} columns",
        "ok": "Ready to import",
        "invalid": "Has errors to fix",
        "tooMany": "File exceeds the {{n}}-row limit per import. Please split into smaller batches.",
        "status": "Status",
        "rowOk": "OK",
        "rowFail": "Error",
        "note": "Showing first 10 rows in preview. The rest is validated server-side."
      },
      "progress": {
        "label": "Importing {{processed}}/{{total}} rows…",
        "hint": "Please keep this window open — import will finish in a few seconds."
      },
      "result": {
        "allOk": "Import succeeded",
        "partial": "Partial import",
        "allFailed": "Import failed",
        "summary": "{{succeeded}}/{{total}} rows succeeded, {{failed}} errors.",
        "errorsHeading": "Some rows failed",
        "downloadErrors": "Download error report",
        "rowLabel": "Row {{index}}"
      },
      "parseError": "Could not read the file. Please try again.",
      "validation": {
        "missingColumn": "Required column \"{{col}}\" is missing from the file.",
        "nameEmpty": "Product name is empty.",
        "invalidPrice": "Invalid price (\"{{raw}}\").",
        "missingBlueprint": "Missing blueprint_id.",
        "skuEmpty": "SKU is empty.",
        "invalidSku": "Invalid SKU (\"{{sku}}\") — only letters/digits/. _ - are allowed.",
        "duplicateSku": "Duplicate SKU within the file (same store): \"{{sku}}\"."
      }
    },
    "columns": {
      "thumbnail": "Image",
      "name": "Name",
      "store": "Store",
      "storeMore": "+{{count}} more",
      "category": "Category",
      "sync": "Sync",
      "created": "Created",
      "lastModified": "Modified",
      "actions": ""
    },
    "publish": {
      "success": "Published \"{{name}}\" to store",
      "failed": "Publish failed"
    },
    "archive": {
      "success": "Archived \"{{name}}\""
    },
    "unarchive": {
      "success": "Restored \"{{name}}\" to draft"
    },
    "statusChange": {
      "failed": "Status update failed"
    },
    "duplicate": {
      "success": "Duplicated \"{{name}}\"",
      "failed": "Duplicate failed"
    },
    "baseProduct": "Base: {{name}}",
    "delete": {
      "success": "Deleted \"{{name}}\"",
      "failed": "Delete failed"
    },
    "lockedHint": "This private product is no longer shared with your store — you can view it but cannot create new orders with it."
  },
  "page": {
    "title": "Product Catalog",
    "subtitle": "Browse our collection of customizable products."
  },
  "filters": {
    "searchPlaceholder": "Search blueprints…",
    "viewMode": "View mode",
    "grid": "Grid",
    "list": "List",
    "allCategories": "All categories",
    "collections": "Collections",
    "priceRange": "Price",
    "min": "Min",
    "max": "Max",
    "clearAll": "Clear all",
    "totalCount": "{{total}} blueprints"
  },
  "sort": {
    "popular": "Most popular",
    "newest": "Newest",
    "priceAsc": "Price: low to high",
    "priceDesc": "Price: high to low",
    "nameAsc": "Name: A → Z"
  },
  "category": {
    "apparel": "Apparel",
    "drinkware": "Drinkware",
    "wall-art": "Wall art",
    "accessories": "Accessories",
    "stationery": "Stationery"
  },
  "collection": {
    "featured": "Featured",
    "new-arrivals": "New arrivals",
    "best-sellers": "Best sellers",
    "seasonal": "Seasonal"
  },
  "chip": {
    "priceMin": "Min ${{cents}}",
    "priceMax": "Max ${{cents}}"
  },
  "card": {
    "from": "From",
    "view": "View",
    "add": "Add to My Products",
    "swatches": "Available colours",
    "tierTooltip": "Tier-resolved price for {{tier}} merchants",
    "added": "Added",
    "addedTooltip": "You already have a product built on this blueprint. See it in My Products."
  },
  "badge": {
    "new": "New",
    "outOfStock": "Out of stock",
    "featured": "Featured"
  },
  "featured": {
    "title": "Featured templates",
    "subtitle": "Curated layouts ready to brand"
  },
  "empty": {
    "title": "No matching blueprints",
    "body": "The catalog is being prepared. Check back shortly.",
    "bodyWithFilters": "No blueprints match the current filters. Try removing some.",
    "reset": "Clear all filters"
  },
  "errors": {
    "loadFailed": "Could not load the catalog. Please retry.",
    "retry": "Retry"
  },
  "detail": {
    "loading": "Loading blueprint…",
    "breadcrumb": "Breadcrumb",
    "description": "Description",
    "notFound": {
      "title": "Blueprint not found",
      "body": "The blueprint you are looking for is no longer available.",
      "backToCatalog": "Back to catalog"
    },
    "tierPrice": {
      "title": "Tier-based pricing",
      "yourTier": "Your tier",
      "dealBadge": "Deal",
      "otherTierTooltip": "Price visible only for your tier",
      "noTierHint": "Your tier is not loaded yet — sign in to see your price."
    },
    "variant": {
      "title": "Variants",
      "color": "Colour",
      "size": "Size",
      "outOfStock": "Out of stock",
      "empty": "No variants available"
    },
    "printAreas": {
      "title": "Print areas",
      "front": "Front",
      "back": "Back",
      "sleeve_left": "Left sleeve",
      "sleeve_right": "Right sleeve"
    },
    "print": {
      "title": "Print areas",
      "subtitle": "Click a zone to view dimensions",
      "mockupAlt": "Garment mockup",
      "printZones": "Print zones",
      "embroideryZones": "Embroidery zones",
      "stitches": "stitches",
      "maxDpi": "Max",
      "maxStitches": "Max stitches"
    },
    "related": {
      "title": "Related products"
    },
    "cta": {
      "addToProducts": "Add to My Products",
      "disabledTooltip": "This blueprint cannot be added right now.",
      "added": "Added to My Products",
      "addedTooltip": "You already have a product built on this blueprint. See it in My Products.",
      "viewMine": "View in My Products"
    },
    "addons": {
      "title": "Add-ons & accessories",
      "addonsLabel": "Add-ons",
      "accessoriesLabel": "Accessories",
      "required": "required"
    },
    "gallery": {
      "thumbStrip": "Mockup thumbnails",
      "openLightbox": "Open full-screen view",
      "lightboxTitle": "Mockup full-screen view",
      "lightboxDescription": "Use arrow keys to navigate, plus and minus to zoom, ESC to close.",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "zoomReset": "Reset zoom",
      "zoomFit": "Fit",
      "close": "Close",
      "prev": "Previous image",
      "next": "Next image",
      "empty": "No mockup available"
    },
    "versionLatest": "{{pinned}} (latest: {{latest}})",
    "edit": "Edit",
    "media": "Media",
    "noImage": "No image",
    "primary": "Primary",
    "general": "General",
    "blueprint": "Blueprint",
    "category": "Category",
    "blueprintVersion": "Blueprint version",
    "baseCost": "Base cost (system → merchant)",
    "createdAt": "Created at",
    "updatedAt": "Updated at",
    "tags": "Tags",
    "variants": "Variants",
    "size": "Size",
    "color": "Color",
    "priceOverride": "Price override",
    "inventory": "Inventory",
    "state": "State",
    "retired": "Retired",
    "restricted": "Reserved",
    "restrictedTitle": "Reserved for another merchant — it cannot be ordered. Contact your account manager to change it.",
    "activeVariant": "Active",
    "pricingPerStore": "Pricing per store",
    "store": "Store",
    "sellingPrice": "Selling price",
    "seo": "SEO",
    "metaTitle": "Meta title",
    "slug": "Slug",
    "metaDescription": "Meta description",
    "customSku": "Custom SKU"
  },
  "wizard": {
    "breadcrumb": "My Products / Create New Product",
    "pageTitle": "Create new product",
    "draftSaved": "Draft saved at {{ts}}",
    "unsavedWarning": "You have unsaved wizard changes. Leaving will discard them.",
    "placeholder": "This step will be available shortly.",
    "title": {
      "step1": "Select Product",
      "step15": "Stores",
      "step2": "Variants & Add-ons",
      "step3": "Add mockup",
      "step4": "Pricing",
      "step5": "Review & Publish"
    },
    "nav": {
      "back": "Back",
      "saveDraft": "Save draft",
      "next": "Next",
      "finish": "Finish",
      "saving": "Saving…",
      "saveChanges": "Save changes"
    },
    "step1": {
      "heading": "Choose a base product to customize",
      "desc": "Pick the blueprint your custom product is based on.",
      "search": "Search blueprints…",
      "filter": "All categories",
      "empty": "No blueprints match the current search.",
      "emptyHint": "Try a different keyword or category.",
      "select": "Select",
      "selected": "Selected",
      "selectedLabel": "Selected blueprint",
      "change": "Change"
    },
    "step15": {
      "title": "Choose target stores",
      "desc": "Pick the stores that should receive this product on publish. You can change this later.",
      "allStores": "Select all",
      "noneStores": "Clear all",
      "targetStores": "{{count}} of {{total}} selected",
      "minOneRequired": "Pick at least one store to continue.",
      "noStores": "You have no connected stores yet.",
      "noStoresHint": "Connect at least one store before creating a product.",
      "connectStore": "Connect a store",
      "loadFailed": "Could not load connected stores. Please retry.",
      "disconnected": "Disconnected"
    },
    "step2": {
      "heading": "Configure variants and add-ons",
      "desc": "Pick which size/color combinations to publish and any add-ons your customers can choose.",
      "noBlueprint": "Please pick a blueprint in Step 1 first.",
      "loadFailed": "Could not load blueprint variants.",
      "matrixEmpty": "This blueprint has no variants yet. Continue to Artwork.",
      "selectAll": "Select all",
      "clearAll": "Clear all",
      "enabledCount": "{{count}} of {{total}} enabled",
      "minOneRequired": "Enable at least one variant to continue.",
      "trackOn": "On",
      "trackOff": "Off",
      "overridePlaceholder": "Override ¢",
      "required": "required",
      "addonsTitle": "Add-ons & accessories",
      "addonsDesc": "Optional surcharges your customer can add at checkout.",
      "addonsLabel": "Add-ons",
      "accessoriesLabel": "Accessories",
      "giftMessage": "Allow customers to add a gift message at checkout",
      "col": {
        "size": "Size",
        "color": "Color",
        "sku": "SKU",
        "inventory": "Track inventory",
        "priceOverride": "Override (¢)",
        "customSku": "Custom SKU"
      },
      "embroidery": {
        "title": "Embroidery configuration",
        "desc": "Stitch type, frame size, and thread palette for embroidery zones.",
        "stitchType": "Stitch type",
        "frameSize": "Frame size (mm)",
        "threadColors": "Thread colors",
        "addColor": "+ Add color",
        "closePalette": "Close",
        "removeColor": "Click to remove",
        "stitch": {
          "flat": "Flat",
          "puff": "Puff (3D)"
        },
        "threadAria": "Thread {{hex}}",
        "color": {
          "black": "Black",
          "white": "White",
          "red": "Red",
          "royalBlue": "Royal Blue",
          "green": "Green",
          "yellow": "Yellow",
          "purple": "Purple",
          "orange": "Orange",
          "teal": "Teal",
          "magenta": "Magenta",
          "brown": "Brown",
          "silver": "Silver",
          "gold": "Gold",
          "pink": "Pink"
        }
      },
      "customSkuDup": "Duplicate custom SKU — it must be unique within the product.",
      "customSkuHint": "Optional. Leave blank to reuse the system SKU when matching orders.",
      "personalized": "Personalized product — every order requires uploading fresh artwork",
      "axisUnresolved": "The {{axis}} options of this blueprint could not be read, so a placeholder is used. Orders for these variants may not be priceable — ask an admin to check the blueprint options."
    },
    "step3": {
      "heading": "Add mockup",
      "desc": "Upload up to 10 product images and choose one as the main image.",
      "dropzone": "Click or drag images here to upload",
      "maxReached": "Maximum of 10 images reached",
      "mainBadge": "Main",
      "remove": "Remove image",
      "setMain": "Set as main",
      "noBlueprint": "Please pick a blueprint in Step 1 first.",
      "loadFailed": "Could not load print areas.",
      "noMockup": "No mockup available for preview.",
      "dropHint": "Drag & drop your artwork here",
      "dropSubhint": "PNG · JPG · SVG · max 25 MB",
      "uploadCta": "Upload file",
      "libraryCta": "Choose from library",
      "validatingHint": "Running design checks…",
      "replace": "Replace",
      "bulkUpload": "Bulk upload tool",
      "mockupAlt": "Garment mockup with print zones",
      "summary": {
        "passed": "passed",
        "failed": "failed",
        "inProgress": "in progress"
      },
      "state": {
        "pending": "Queued",
        "uploading": "Uploading…",
        "validating": "Validating…",
        "passed": "Passed",
        "failed": "Failed"
      },
      "errors": {
        "unsupportedMime": "Only PNG, JPG, or SVG files are allowed.",
        "tooLarge": "File is too large. Maximum is 25 MB."
      },
      "libraryLoadFailed": "Could not load your library. Try again.",
      "libraryTitle": "Choose from library",
      "libraryEmpty": "Your library is empty.",
      "libraryEmptyHint": "Upload a file via the drag-drop area below — it will appear here next time."
    },
    "step4": {
      "heading": "Set retail price per store",
      "desc": "Charging is always USD. Negative-margin cells are highlighted in red.",
      "noBlueprint": "Please pick a blueprint in Step 1 first.",
      "noStores": "Please select at least one store in Step 1.5 to set pricing.",
      "noVariants": "Please enable at least one variant in Step 2 to set pricing.",
      "col": {
        "variant": "Variant",
        "cost": "Base cost"
      },
      "priceLabel": "Retail price for {{variant}} on {{store}}",
      "negativeMargin": "Loss",
      "noCost": "No cost data",
      "summaryTitle": "Pricing summary",
      "summaryDesc": "Live margin recap for the priced cells. Charging is always USD.",
      "completion": "Cells priced",
      "negativeCells": "Negative margin",
      "minMargin": "Min margin",
      "avgMargin": "Avg margin",
      "maxMargin": "Max margin",
      "worstCell": "Loss-leader",
      "usdNote": "Source of truth: USD. Display currency is informational only."
    },
    "step5": {
      "heading": "Review and publish your product",
      "desc": "Double-check every step before publishing — sync jobs run immediately on publish.",
      "edit": "Edit",
      "saveDraft": "Save as draft",
      "saving": "Saving…",
      "publish": "Publish product",
      "draftSavedToast": "Draft saved",
      "publishSuccess": "Product published — sync jobs are running.",
      "publishError": "Could not publish product.",
      "productInfoTitle": "Product information",
      "titleLabel": "Title",
      "descLabel": "Description",
      "tagsLabel": "Tags",
      "tagPlaceholder": "Add a tag and press Enter",
      "removeTag": "Remove {{tag}}",
      "platformFieldsTitle": "Per-store publish fields",
      "noPlatformFields": "No stores selected — go back to Step 1.5 to choose at least one.",
      "tagsPlaceholder": "Comma-separated",
      "cards": {
        "blueprint": "Blueprint",
        "stores": "Publish to stores",
        "variants": "Variants",
        "artwork": "Artwork",
        "pricing": "Pricing",
        "noBlueprint": "No blueprint selected.",
        "noStores": "No stores selected.",
        "connected": "Connected",
        "pending": "Pending",
        "variantsCount": "{{count}} of {{total}} enabled",
        "artworkCount": "{{passed}}/{{total}} zones validated",
        "pricingCount": "{{count}} priced cells",
        "mockup": "Mockup",
        "mainSet": "selected",
        "mainMissing": "not selected",
        "mockupEmpty": "No images uploaded",
        "mockupCount": "{{count}} image(s) · main image {{main}}"
      },
      "publishConfirm": {
        "title": "Publish product?",
        "desc": "This will create the product and dispatch sync jobs to the selected stores.",
        "product": "Product",
        "untitled": "(untitled)",
        "stores": "Sync to",
        "pricing": "Pricing",
        "pricingCount": "{{count}}/{{total}} cells priced",
        "syncWarning": "Sync jobs run asynchronously — listing IDs will appear in My Products as each store responds.",
        "cancel": "Cancel",
        "publishing": "Publishing…",
        "confirm": "Publish"
      },
      "fields": {
        "etsy": {
          "tags": "Tags (max 13)",
          "materials": "Materials",
          "whoMade": "Who made it",
          "whenMade": "When was it made"
        },
        "amazon": {
          "category": "Category",
          "keywords": "Keywords",
          "brand": "Brand"
        },
        "tiktok": {
          "weight": "Weight (g)",
          "shippingCategory": "Shipping category"
        },
        "shopify": {
          "seoTitle": "SEO title",
          "seoDescription": "SEO description"
        },
        "woo": {
          "taxClass": "Tax class",
          "weight": "Weight (g)"
        },
        "generic": {
          "notes": "Notes"
        }
      }
    },
    "draft": {
      "idle": "Auto-save ready",
      "saving": "Saving…",
      "savedAt": "Saved at {{ts}}",
      "localOnly": "Saved locally",
      "resumeTitle": "Resume your draft?",
      "resumeDesc": "We saved your previous work. You can pick up where you left off, or start fresh.",
      "resumeLastSaved": "Last saved {{when}}",
      "resumeConfirm": "Resume draft",
      "resumeDiscard": "Start fresh",
      "toastSaved": "Draft saved to server",
      "toastNoBlueprint": "Can't save draft — pick a blueprint in step 1 first.",
      "toastError": "Server save failed — draft saved locally",
      "resumed": "Draft reopened"
    },
    "breadcrumbEdit": "My Products / Edit Product",
    "pageTitleEdit": "Edit product"
  },
  "settings": {
    "title": "Product Settings",
    "subtitle": "Configure default settings for your products.",
    "back": "My Products",
    "save": "Save changes",
    "saving": "Saving…",
    "savedAt": "Saved at {{ts}}",
    "pricing": {
      "title": "Default Pricing",
      "subtitle": "Applied to new products when no per-product price is set.",
      "margin": "Default profit margin",
      "marginHint": "Applied when computing list price for new products.",
      "currency": "Display currency",
      "currencyHint": "Settlement currency stays USD.",
      "autoSku": "Auto-generate SKU",
      "autoSkuHint": "Automatically create SKU codes for new products."
    },
    "printMethod": {
      "title": "Default Print Method",
      "subtitle": "Defaults applied to artwork & print routing.",
      "method": "Print method",
      "minDpi": "Minimum DPI",
      "minDpiHint": "Artwork below this threshold is rejected.",
      "maxFile": "Max file size",
      "formats": "Accepted formats",
      "formatsHint": "Click to toggle each format.",
      "autoResize": "Auto-resize artwork",
      "autoResizeHint": "Resize artwork to fit print area on upload.",
      "options": {
        "dtg": "DTG (direct-to-garment)",
        "dtf": "DTF (direct-to-film)",
        "sublimation": "Sublimation",
        "embroidery": "Embroidery",
        "screen_print": "Screen print"
      }
    },
    "shipping": {
      "title": "Default Shipping",
      "subtitle": "Origin + auto-sync defaults for new products.",
      "origin": "Origin country",
      "leadTime": "Lead time (days)",
      "autoSync": "Auto-sync new products",
      "autoSyncHint": "New products are pushed immediately to all connected stores."
    },
    "notifications": {
      "title": "Notifications",
      "subtitle": "Toggle alerts per product event.",
      "event": "Event",
      "email": "Email",
      "inApp": "In-app",
      "events": {
        "productPublished": "Product published",
        "productSyncFailed": "Product sync failed",
        "productOutOfStock": "Product out of stock",
        "bulkImportFinished": "Bulk import finished"
      }
    },
    "aria": {
      "emailEvent": "Email {{event}}",
      "inAppEvent": "In-app {{event}}"
    }
  },
  "wizardDrafts": {
    "breadcrumb": "Products / In progress",
    "title": "Drafts in progress",
    "hint": "Drafts are autosaved while you create a product. Auto-deleted after 30 days idle.",
    "empty": "No drafts yet.",
    "startNew": "Create a new product",
    "untitled": "Untitled",
    "resume": "Resume",
    "confirmDelete": "Delete this draft?",
    "deleted": "Draft deleted",
    "deleteFailed": "Failed to delete draft",
    "col": {
      "product": "Product",
      "blueprint": "Blueprint",
      "progress": "Progress",
      "savedAt": "Saved at",
      "expiresAt": "Expires"
    },
    "relative": {
      "expiringSoon": "expiring soon",
      "oneDayLeft": "1 day left",
      "daysLeft": "{{days}} days left"
    }
  },
  "catalog": {
    "cta": {
      "wizardDrafts": "In progress ({{count}})"
    }
  }
}
